import { useStore } from "vuex";
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import PostComment from "../PostComment/PostComment.vue";

export default {
    name: "PostComments",
    components: {
        PostComment
    },
    props: {
        canReply: {
            type: Boolean,
            default: false
        },
        isFrivilligContext: {
            type: Boolean,
            default: false
        },
        postId: {
            type: String,
            required: true
        },
        groupId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()

        const commentId = ref()
        const comments = computed(() => store.state.forum.post_comments[props.postId])

        const scrollToComment = (id) => {
            const element = document.getElementById(id)
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', alignToTop: true })
            }
        }

        watch(
            comments,
            async (newComments) => {
                if (newComments && commentId.value) {
                    await nextTick()
                    scrollToComment(commentId.value)
                }
            },
            { immediate: true }
        );

        onMounted(() => {
            store.dispatch("forum/getPostComments", {
                postId: props.postId,
                pageId: store.state.main.page_id
            })

            const params = new URLSearchParams(window.location.search);
            commentId.value = params.get('commentId');
        })

        const getLabel = (labelKey) => store.getters['labels/getLabel']({labelCollection: 'PostCommments', labelKey})

        return {
            comments,
            getLabel
        }
    }
}